import { useContext, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import ReBox from "../ReBox";
import { GlobalContext } from "../Context";
import moment from "moment";
import MovingIcon from "@mui/icons-material/Moving";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { green, purple, white } from "../../../theme/colours";

const WinnerCard = ({ winnerData, campaignType }) => {
  const { largeView, tabletView, mobileView, desktopView } =
    useContext(GlobalContext);
  const {
    userName: username,
    startDate: { value: startDate },
    endDate: { value: endDate },
    teamName: team,
  } = winnerData;
  const [chipProps, setChipProps] = useState(null);

  const containerStyle = {
    width: tabletView ? "calc(50% - 0.5rem)" : mobileView ? "100%" : "23.5%",
    ...(desktopView && {
      "&:not(:last-child)": {
        mr: "3%",
      },
    }),
    ...(tabletView && {
      "&:nth-child(2n+1)": {
        mr: "1rem",
      },
    }),
  };
  const winnerCardStyle = {
    display: "flex",
    flexDirection: "column",
    padding: "1rem",
    borderRadius: "10px",
    overflow: "hidden",
    mb: (tabletView || mobileView) && "0.5rem",
    background: desktopView ? "#F4F2F7" : white,
    boxShadow: "none",
  };
  const dateHeaderStyle = {
    width: "100%",
    fontSize: "1.125rem",
    fontWeight: 700,
    mb: "0.5rem",
  };
  const winnerInfoStyle = {
    display: "flex",
    width: "100%",
  };
  const personalInfoStyle = {
    width: "55%",
    display: "flex",
    flexDirection: "column",
    "& p": {
      fontSize: "0.875rem",
    },
  };
  const scoreInfoStyle = {
    width: "45%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  };
  const userNameStyle = {
    fontWeight: 700,
    mb: "0.25rem",
  };
  const boldStyleScore = {
    ml: "0.25rem",
    fontWeight: 700,
  };
  const ogChipStyle = {
    "& img": {
      height:
        winnerData.type?.toLowerCase() === "phone"
          ? "8px"
          : largeView
          ? "15px"
          : "12px",
      margin: "0 0.25rem 0 0",
      fill: white,
    },
  };
  const weekSvgStyle = {
    background: purple[1],
    "& svg": {
      width: "1rem",
      color: white,
      mr: "0.25rem",
    },
  };
  const poolSvgStyle = {
    background: purple[1],
    "& svg": {
      width: "0.75rem",
      color: white,
      mr: "0.25rem",
    },
  };

  useEffect(() => {
    if (!winnerData) {
      setChipProps(null);
      return;
    }

    switch (campaignType) {
      case "weekImprovement":
        setChipProps({
          iconSvg: <MovingIcon />,
          text: `by ${winnerData.increase}`,
          sx: weekSvgStyle,
        });
        break;
      case "moneyPot":
        setChipProps({
          iconSvg: <EmojiEventsIcon />,
          text: `Top ${winnerData.rank}`,
          sx: poolSvgStyle,
        });
        break;
      default:
        setChipProps({
          iconSrc: `images/mainIconsWhite/${winnerData.scoreType?.toLowerCase()}.svg`,
          text: winnerData.score,
          sx: ogChipStyle,
        });
        break;
    }
  }, [campaignType, winnerData]);

  const DisplayCard = ({ iconSrc, iconSvg, text, sx }) => {
    const scoreBoxStyle = {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "0.25rem 0.75rem",
      background: green[2],
      borderRadius: "10px",
      height: largeView ? "1.35rem" : "1.25rem",
      ...sx,
    };

    return (
      <Box sx={scoreBoxStyle}>
        {iconSvg
          ? iconSvg
          : iconSrc && <Box component="img" src={iconSrc} alt="chip icon" />}
        <Typography sx={boldStyleScore} variant="body1" color={white}>
          {text}
        </Typography>
      </Box>
    );
  };

  return (
    <Box sx={containerStyle}>
      <Typography sx={dateHeaderStyle}>
        {`${moment(startDate).format("MMM D, YYYY")} - ${moment(endDate).format(
          "MMM D, YYYY",
        )}`}
      </Typography>
      <ReBox style={winnerCardStyle}>
        <Box sx={winnerInfoStyle}>
          <Box sx={personalInfoStyle}>
            <Typography sx={userNameStyle}>
              {username ? username : "N/A"}
            </Typography>
            <Typography>{team}</Typography>
          </Box>
          <Box sx={scoreInfoStyle}>
            {chipProps && <DisplayCard {...chipProps} />}
          </Box>
        </Box>
      </ReBox>
    </Box>
  );
};

export default WinnerCard;
